import type { IntlShape } from "react-intl";
import { COwithoutFeatDataType } from "../types/connected-object"

import personImg from "./../assets/icons/svg/pendentif-humain.svg";

import CardFeatureStyle from "./../components/card/CardFeature.module.css";
import { FeatureEnum, FeatureMetaDataType, FeatureType } from "../types/feature";

/** Message ids for feature titles — format at call sites with intl.formatMessage */
export const FEATURE_TITLE_IDS: Partial<Record<FeatureEnum, string>> = {
  [FeatureEnum.Human]: "features.human.title",
};

/** Message ids for feature descriptions */
export const FEATURE_DESCRIPTION_IDS: Partial<Record<FeatureEnum, string>> = {
  [FeatureEnum.Human]: "features.human.description",
};

export type FeatureVisualMeta = Omit<FeatureMetaDataType, "title" | "description"> & {
  titleId: string;
  descriptionId?: string;
};

export const getFeatureMetaData = (feature: string): FeatureVisualMeta | undefined => {
  switch (feature) {
    case FeatureEnum.Human:
      return {
        titleId: FEATURE_TITLE_IDS[FeatureEnum.Human]!,
        descriptionId: FEATURE_DESCRIPTION_IDS[FeatureEnum.Human],
        icon: personImg,
        decor: CardFeatureStyle.bgLinearOrange,
      };
    default:
      return undefined;
  }
};

/** Format feature title with intl */
export const getFeatureLabel = (intl: IntlShape, type: string): string | undefined => {
  const titleId = FEATURE_TITLE_IDS[type as FeatureEnum] ?? getFeatureMetaData(type)?.titleId;
  return titleId ? intl.formatMessage({ id: titleId }) : undefined;
};

/** Format feature description with intl */
export const getFeatureDescription = (intl: IntlShape, type: string): string | undefined => {
  const descriptionId =
    FEATURE_DESCRIPTION_IDS[type as FeatureEnum] ?? getFeatureMetaData(type)?.descriptionId;
  return descriptionId ? intl.formatMessage({ id: descriptionId }) : undefined;
};

export const attachActiveFeature = (data: COwithoutFeatDataType[]): (COwithoutFeatDataType & {activeFeature: FeatureType | null})[] => {
  return data.map(co => {
    return {
      ...co,
      activeFeature: co.features.filter(feat => feat.isActive)[0] ?? null
    }
  })
}
